﻿/// <reference path="walkinManager.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../AppointmentBook/js/services/AppointmentBookActionsService.ts" />

module Meevo.Plugins.WalkinManager {
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import WaitListStatus = Meevo.Model.WaitListStatus;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;

    export enum WalkInWizardTypeEnum {
        Add = 0,
        Edit
    }

    class WalkinManagerController {

        static $inject = [
            'meevo.AppSettings', 'meevo.components.common.DataService',
            'meevo.components.modal.ModalService', 'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService', 'meevo.components.common.SecurityService',
            '$rootScope', '$scope', '$state', 'meevo.ContextParams', 'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService', '$translate', '$q', '$http',
            'meevo.plugins.walkinManager.WalkinAppointmentService',
            'meevo.plugins.walkinManager.WalkInSettingsService',
            'meevo.components.tracking.TrackingService',
            'appointmentBookActionsService'
        ];

        private securityKeys = Meevo.Components.Common.SecurityKeys;
        private securityParts = Meevo.Components.Common.SecurityParts;
        private modalOptions: Meevo.Components.Modal.IModalOptions;
        public showEstimated: boolean;
        public stateEnum: any;
        public statusEnumList: any;
        public transitionEnumList: any;
        public finalEnumList: any;
        public viewState: WaitListStatus;
        public securityOptions: any;
        public filteredAppointmentList: Array<IWalkinAppointment>;
        public clientFilter: string;
        private sortTypes: Meevo.Model.WaitListSortType[] = [];
        public selectedNoteId: number;
        public selectedNoteType: string;

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: ng.IScope,
            protected $state: angular.ui.IState,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: any,
            protected $q: ng.IQService,
            protected $http: ng.IHttpService,
            protected walkinAppointmentService: Meevo.Plugins.WalkinManager.IWalkinAppointmentService,
            protected settingsService: Meevo.Plugins.WalkinManager.IWalkInSettingsService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected appointmentBookActionsService: any
        ) {

            this.clientFilter = '';
            this.stateEnum = WaitListStatus;
            this.statusEnumList = Meevo.Model.WalkInStatusEnum;
            this.transitionEnumList = Meevo.Model.AppointStateEnum;
            this.finalEnumList = Meevo.Model.AppointFinalStateEnum;
            this.viewState = WaitListStatus.Default;
            this.sortTypes[WaitListStatus.Default] = Meevo.Model.WaitListSortType.Priority;
            this.sortTypes[WaitListStatus.NoShow] = Meevo.Model.WaitListSortType.Priority;
            this.sortTypes[WaitListStatus.InProgress] = Meevo.Model.WaitListSortType.Priority;
            this.modalOptions = {
                templateUrl: 'app/plugins/walkinManager/addToWaitlist/walkinManagerAddNewClientTemplate.html',
                controller: 'meevo.plugins.walkinManager.addToWaitlist.WalkinManagerModalController',
                controllerAs: 'vm',
                bindToController: true,
                multiple: true,
                locals: {
                    item: null
                },
                onComplete: () => {
                    angular.element('v-pane-header').attr('tabindex', -1);
                }
            };

            console.log('hi2')

            this.$rootScope.$on('startDataLoading', () => {
                this.getWalkinAppointments();
            });

            this.securityOptions = {
                settingsButton: false,
                addToWaitList: false
            };

            busyService.start();
            this.settingsService.fetchSettings()
                .then(() => {
                    this.showEstimated = !this.settingsService.settings.walkInDisplayMonitorShowTotalTime;

                    $q.all([
                        this.getWalkinAppointments(false),
                        this.securityService.checkSecurityKey(this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                            .then((securityCode: SecurityAccessEnum) => {
                                this.securityOptions.settingsButton = securityCode === SecurityAccessEnum.Grant;
                            }),
                        this.securityService.checkSecurityKey(this.securityKeys.APPOINTMENTS_WALKINMANAGER_WAITLIST_ACTION + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE)
                            .then((securityCode: SecurityAccessEnum) => {
                                this.securityOptions.addToWaitList = securityCode === SecurityAccessEnum.Grant;
                            }),

                    ])
                        .finally(() => {
                            busyService.stop();
                        })
                })
                .catch(() => {
                    busyService.stop();
                });
        }

        public get sortType(): Meevo.Model.WaitListSortType {
            return this.sortTypes[this.viewState];
        }

        public set sortType(type: Meevo.Model.WaitListSortType) {
            this.sortTypes[this.viewState] = type;
        }

        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        };

        public getWalkinAppointments(withBusyService: boolean = true): angular.IPromise<any> {
            if (withBusyService) {
                this.busyService.start();
            }

            return this.walkinAppointmentService.fetchWalkInAppointments(this.viewState, Number(this.sortType))
                .finally(() => {
                    if (withBusyService) {
                        this.busyService.stop();
                    }
                    this.clientFilter = '';
                    this.filteredAppointmentList = this.walkinAppointmentService.walkinAppointmentList;
                });
        }

        public updateFilterList = () => {
            if (_.isEmpty(this.clientFilter)) {
                this.filteredAppointmentList = this.walkinAppointmentService.walkinAppointmentList;
            } else {
                this.filteredAppointmentList = _.filter(this.filteredAppointmentList, (appt) => {
                    return appt.clientDisplayName.toLowerCase().indexOf(this.clientFilter.toLowerCase()) >= 0;
                });
            }
        }

        public sortTypeChanged = () => {
            this.getWalkinAppointments();
        }

        public addRequest = () => {
            let options = angular.copy(this.modalOptions);

            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerPage, Model.VerbEnum.AddToWalkInManagerButtonClicked, null, null));
            if (this.checkLocationAvailability()) {
                options.locals['windowType'] = WalkInWizardTypeEnum.Add;
                options.multiple = true;
                this.modalService.showCustom(options)
                    .then((result) => {
                        this.changeViewState(WaitListStatus.Default);
                    })
                    .finally(() => {
                        this.getWalkinAppointments();
                    });
            } else {
                this.$translate('MESSAGE_WALKIN_NOT_ACCEPTING_SUBMISSION')
                    .then((text) => {
                        this.modalService
                            .alert(`${this.settingsService.settings.businessName} ${text}`,
                                Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                    }, () => {
                        this.modalService
                            .alert(`${this.settingsService.settings.businessName} is currently not accepting any wait list submission at this time`,
                                Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                    });
            }
        };

        public editRequest = (item) => {
            let options = angular.copy(this.modalOptions);
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerPage, Model.VerbEnum.EditButtonClicked, null, item.appointmentId));

            if (item.appointmentServiceFinalState == this.finalEnumList.CheckedOut) {
                this.$translate('MESSAGE_CANNOT_MODIFY_CHECKED_OUT_SERVICES')
                    .then((text) => {
                        this.modalService.alert(text, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                    });
            } else {
                if (this.checkLocationAvailability()) {
                    this.dataService.getItem('walkinAppointment', item.id)
                        .then((item: IWalkinAppointment | any) => {
                            options.locals['item'] = item;
                            options.locals['windowType'] = WalkInWizardTypeEnum.Edit;
                            this.modalService.showCustom(options)
                                .finally(() => {
                                    this.getWalkinAppointments();
                                });
                        });
                } else {
                    this.$translate('MESSAGE_WALKIN_NOT_ACCEPTING_SUBMISSION')
                        .then((text) => {
                            this.modalService
                                .alert(`${this.settingsService.settings.businessName} ${text}`,
                                    Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                        }, () => {
                            this.modalService
                                .alert(`${this.settingsService.settings.businessName} is currently not accepting any wait list submission at this time`,
                                    Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                        });
                }
            }

        };

        public patchRequest(item: IWalkinAppointment, model: Object): void {
            this.busyService.start();
            this.dataService.patch('walkinAppointment', {
                model: model
            }, item.id)
                .then(() => {
                    this.getWalkinAppointments();
                });
        }

        public checkoutFromList = (item: Meevo.Plugins.WalkinManager.IWalkinAppointment) => {
            let options = {
                templateUrl: 'app/plugins/walkinManager/assignEmployee/assignment.modal.html',
                controller: 'meevo.plugins.walkinManager.assignEmployee.AssignmentModalController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    item: item,
                }
            };

            this.modalService.confirm('MESSAGE_CHECK_IN_ALL_SERVICES', ModalTranslationModes.Translate)
                .then(() => {
                    options.locals['allItems'] = true;
                    this.modalService.showCustom(options)
                        .then(() => this.getWalkinAppointments());
                })
                .catch(() => {
                    options.locals['allItems'] = false;
                    this.modalService.showCustom(options)
                        .then(() => this.getWalkinAppointments());
                });
        }

        public sendSms = (item: Meevo.Plugins.WalkinManager.IWalkinAppointment) => {
            let options = {
                templateUrl: 'app/plugins/walkinManager/sendSms/sendSms.modal.html',
                controller: 'meevo.plugins.walkinManager.sendSms.SendSmsModalController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    item: item
                }
            };
            this.modalService.showCustom(options)
                .then(() => {
                    this.getWalkinAppointments();
                });

        };

        public goToSettings(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.walkinManagerSettings
            });
        }

        public deleteRequest = (item) => {
            let options = {
                templateUrl: "app/plugins/walkinManager/removeFromWaitlist/removal.modal.html",
                controller: "meevo.plugins.walkinManager.removeFromWaitlist.RemovalModalController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    item: item
                }
            };

            this.modalService.showCustom(options);
        };

        public toggleEstimatedTotal = () => {
            this.showEstimated = !this.showEstimated;
            this.walkinAppointmentService.updateTime();
        };

        public toggleCheckInStatus(item: IWalkinAppointment): void {
            this.modalService.confirmHandler('MESSAGE_CHECK_IN_ALL_SERVICES', ModalTranslationModes.Translate)
                .then((response) => {
                    this.busyService.start();
                    this.walkinAppointmentService.updateAllAppointmentServiceByClientId(item.clientId.toString(), {
                        AppointmentDate: moment(item.startDateTime).toDate().toDateString(),
                        PatchLocalAppointmentsOnly: true,
                        WalkinStatus: response ? Meevo.Model.WalkInStatusEnum.WaitingAndPresent : Meevo.Model.WalkInStatusEnum.WaitingButNotPresent
                    }).then(() => this.getWalkinAppointments());
                })
                .catch(() => {
                    this.patchRequest(item, {
                        entityVersion: item.entityVersion,
                        statusEnum: item.isCheckedIn ? Meevo.Model.WalkInStatusEnum.WaitingButNotPresent : Meevo.Model.WalkInStatusEnum.WaitingAndPresent
                    });
                });
        }

        public reinsertToWaitList = (item: IWalkinAppointment): void => {
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerPage, Model.VerbEnum.ItemReinsertClicked, null, item.id));

            let model = {
                entityVersion: item.entityVersion,
                transitionStateEnum: Meevo.Model.AppointStateEnum.WalkInPending
            };
            this.patchRequest(item, model);
        };

        /**
         * Navigate to client editing Main tab
         * @param {string} clientId
         * */
        public navigateToClient = (clientId: string) => {

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: {
                    callback: null,
                    callbackState: null,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    id: clientId
                }
            });
        };

        public navigateToAppointmentEditor = (appointment: IWalkinAppointment): void => {
            if (appointment.appointmentServiceTransitionState == Meevo.Model.AppointStateEnum.CheckedIn &&
                appointment.appointmentServiceFinalState !== Meevo.Model.AppointFinalStateEnum.CheckedOut) {

                var appointmentDate = new Date(appointment.startDateTime);
                appointmentDate.setHours(0, 0, 0, 0);

                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                    stateName: this.appSettings.ROUTE_NAMES.appointmentBook,
                    stateParams: {
                        actionState: Meevo.Model.AppointmentBookState.EditAppointment,
                        actionStatePayload: {
                            appointmentId: appointment.appointmentId,
                            id: appointment.appointServiceId,
                            appointmentDate: appointmentDate,
                            employeeId: appointment.employeeId
                        }
                    }
                })
            }
        };

        public launchRegister = (appointment: IWalkinAppointment): void => {
            this.modalService.confirm('MESSAGE_CHECK_OUT_ALL_SERVICES', ModalTranslationModes.Translate)
                .then(() => {
                    this.busyService.start();
                    this.$q.all(this.walkinAppointmentService.walkinAppointmentList
                        .filter((app) => app.clientId === appointment.clientId)
                        .map((app) => this.dataService.getItem('AppointmentService', new Guid(app.appointServiceId))))
                        .then((res: any[]) => {
                            this.busyService.stop();
                            this.$rootScope.$broadcast('gotoState', {
                                stateName: 'register', stateParams: {
                                action: Meevo.Components.Common.Messages.MANUAL_SALE_LINES,
                                services: res.filter((item) => item.finalState !== Meevo.Model.AppointFinalStateEnum.CheckedOut)
                                    .map((item) => ({serviceId: item.serviceId, appointmentServiceId: item.id})),
                                clientId: appointment.clientId,
                                employeeId: appointment.employeeId
                            }});
                        });
                })
                .catch(() => {
                    this.busyService.start();
                    this.dataService.getItem('AppointmentService', new Guid(appointment.appointServiceId))
                        .then((response: any) => {
                            this.busyService.stop();
                            if (response.finalState !== Meevo.Model.AppointFinalStateEnum.CheckedOut) {
                                this.$rootScope.$broadcast('gotoState', {
                                    stateName: 'register', stateParams: {
                                        action: Meevo.Components.Common.Messages.MANUAL_SALE_LINE,
                                        appointmentServiceId: appointment.appointServiceId,
                                        serviceId: appointment.serviceId,
                                        clientId: appointment.clientId,
                                        employeeId: appointment.employeeId
                                    }
                                });
                            }
                        });
                });
        }

        public changeViewState = (state: WaitListStatus) => {

            switch (state) {
                case WaitListStatus.Default:
                    this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerPage, Model.VerbEnum.Viewed, null, null));
                    break;
                case WaitListStatus.NoShow:
                    this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerPage, Model.VerbEnum.NoShowsClicked, null, null));
                    break;
                case WaitListStatus.InProgress:
                    this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WalkInManagerPage, Model.VerbEnum.InProgressCompleteClick, null, null));
                    break;
            }

            this.walkinAppointmentService.walkinAppointmentList.length = 0;
            this.viewState = state;
            this.getWalkinAppointments();
        };

        /**
         * Check if business is working today
         * */
        private checkLocationAvailability(): boolean {
            const currentLocale = moment.locale();
            moment.locale('en');
            let {walkInHours} = this.settingsService.settings,
                todayDay = moment().format('dddd');

            moment.locale(currentLocale);

            let result = _.findWhere(walkInHours, {'weekdayNameDisplay': todayDay, 'isEnabled': true});

            return Boolean(result);
        }

        public selectNote(idx, selectedNoteType): void {
            event.stopPropagation();
            if (this.selectedNoteId !== idx || this.selectedNoteType !== selectedNoteType) {
                this.selectedNoteId = idx;
                this.selectedNoteType = selectedNoteType;
            } else {
                this.selectedNoteId = null;
                this.selectedNoteType = null;
            }
        }
    }

    angular.module('meevo.plugins.walkinManager')
        .controller('meevo.plugins.walkinManager.WalkinManagerController', WalkinManagerController);
}
